import style from "./style.scss";
import Link from "../../components/link";
import { mergeClasses } from "../../components/helpers";
import { lookupByUrl } from "../../settings/route-data-lookup";

const ReviewItem = ({
  external = false,
  href,
  useTitle = false,
  img = undefined,
  title = undefined,
  description = undefined,
  large = false,
}) => {
  const pageInfo = lookupByUrl(href);

  // Assign the tag names dynamically
  const TitleTag = useTitle ? "h2" : "p";

  return (
    <Link
      class={mergeClasses([style.reviewItem, large ? style.large : null])}
      external={external}
      href={href}
    >
      <div class={style.imgWrapper}>
        <img
          src={img ? img : pageInfo.item_img}
          alt={title ? title : pageInfo.item_title}
        />
      </div>
      <div class={style.text}>
        <TitleTag class={style.title}>
          {title ? title : pageInfo.item_title}
        </TitleTag>
        <p class={style.description}>
          {description ? description : pageInfo.item_description}
        </p>
      </div>
    </Link>
  );
};
export default ReviewItem;
